// extracted by mini-css-extract-plugin
export default {"ppe-icon-actions":"Sites_ppe-icon-actions__8bCkj","edit":"Sites_edit__ItEut","delete":"Sites_delete__DNO5h"};